import { render } from "./CollectionQualityChecks.vue?vue&type=template&id=8b344db6&scoped=true"
import script from "./CollectionQualityChecks.vue?vue&type=script&lang=js"
export * from "./CollectionQualityChecks.vue?vue&type=script&lang=js"

import "./CollectionQualityChecks.vue?vue&type=style&index=0&id=8b344db6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b344db6"]])

export default __exports__